export default __webpack_public_path__ + "static/media/gold-box.59143049.svg";